import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import AlumnosProductosSeguimientoContent from './components/AlumnosProductosSeguimientoContent';

const AlumnosProductosSeguimientoListado = () => {

    return (
        <>

            <TemplateDashboard>
                <AlumnosProductosSeguimientoContent />
            </TemplateDashboard>

        </>
    )
};

export default AlumnosProductosSeguimientoListado;